import React from 'react';
import wImg_1 from '../../images/about/about_image_5_1.webp'
import wImg_2 from '../../images/about/about_image_5_2.webp'
import sIcon1 from '../../images/icons/icon_check_2.svg'
import sIcon2 from '../../images/icons/icon_leaf.svg'
import sIcon3 from '../../images/icons/icon_box.svg'
import sIcon4 from '../../images/icons/icon_receipt_add.svg'
import sIcon5 from '../../images/icons/icon_monitor.svg'
import sIcon6 from '../../images/icons/icon_microscope.svg'

const Policy = [
    {
        title: 'Quality Comes First',
        icon: sIcon1,
    },
    {
        title: 'Flexible Cooperation',
        icon: sIcon2,
    },
    {
        title: 'On-time Delivery',
        icon: sIcon3,
    },
    {
        title: 'Transparent Costs',
        icon: sIcon4,
    },
    {
        title: 'Qualified Developers',
        icon: sIcon5,
    },
    {
        title: 'Quick Scale-up',
        icon: sIcon6,
    },


]


const WhyUs = (props) => {

    return (
        <section className="service_section section_space bg-light1">
            <div className="container">
                <div className="row align-items-center justify-content-lg-between">
                    <div className="col-lg-6">
                        <div className="image_wrap">
                            <img src={wImg_1} alt="Lens & Lifestyle - About"/>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="ps-lg-5">
                            <div className="heading_block">
                                <div className="heading_focus_text">
                                    <span className="badge bg-secondary text-white">Our </span>
                                    Approach
                                </div>
                                <h2 className="heading_text mb-0-">
                                    How We Work
                                </h2>
								<p className="heading_description mb-20">
                                    Our process is simple, refined, and result-oriented.
                                </p>
								<p className="heading_description mb-20">
                                    We begin by understanding your brand, your audience, and your goals. From there, we craft a tailored strategy backed by creativity and execution.
                                </p>
								<ul className="icon_list unordered_list_block mb-3">
									<li>
										<span className="icon_list_icon">
											<i className="fa-solid fa-circle fa-fw"></i>
										</span>
										<span className="icon_list_text">
											Concept & Planning
										</span>
									</li>
									<li>
										<span className="icon_list_icon">
											<i className="fa-solid fa-circle fa-fw"></i>
										</span>
										<span className="icon_list_text">
											Creative Direction
										</span>
									</li>
									<li>
										<span className="icon_list_icon">
											<i className="fa-solid fa-circle fa-fw"></i>
										</span>
										<span className="icon_list_text">
											Professional Production
										</span>
									</li>
									<li>
										<span className="icon_list_icon">
											<i className="fa-solid fa-circle fa-fw"></i>
										</span>
										<span className="icon_list_text">
											Post-Production & Delivery
										</span>
									</li>
								</ul>								
								<p className="heading_description mb-20">
                                    Every step is handled with precision to ensure premium quality and impactful results.
                                </p>
                            </div>	
							
                            <ul className="service_facilities_group unordered_list" style={{display: "none"}}>
                                {Policy.map((policy, pitem) => (
                                    <li key={pitem}>
                                        <strong className="iconbox_block layout_icon_left">
                                            <span className="iconbox_icon">
                                                <img src={policy.icon} alt="Dollar SVG Icon" />
                                            </span>
                                            <span className="iconbox_content">
                                                <strong className="iconbox_title mb-0">{policy.title}</strong>
                                            </span>
                                        </strong>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
			
			<div className="container">
                <div className="row align-items-center justify-content-lg-between">
                    
                    <div className="col-lg-6">
                        <div className="ps-lg-51">
                            <div className="heading_block">
                                <div className="heading_focus_text">
                                    <span className="badge bg-secondary text-white">What We </span>
                                    Offer
                                </div>
                                <h2 className="heading_text mb-0-">
                                    What We Do
                                </h2>
								<p className="heading_description mb-20">
                                    We create content that doesn’t just look good — it performs.
                                </p>
								<p className="heading_description mb-20">
                                    From cinematic videos to strategic digital presence, we help brands:
                                </p>
								<ul className="icon_list unordered_list_block mb-3">
									<li>
										<span className="icon_list_icon">
											<i className="fa-solid fa-circle fa-fw"></i>
										</span>
										<span className="icon_list_text">
											Build identity
										</span>
									</li>
									<li>
										<span className="icon_list_icon">
											<i className="fa-solid fa-circle fa-fw"></i>
										</span>
										<span className="icon_list_text">
											Capture attention
										</span>
									</li>
									<li>
										<span className="icon_list_icon">
											<i className="fa-solid fa-circle fa-fw"></i>
										</span>
										<span className="icon_list_text">
											Engage audience
										</span>
									</li>
									<li>
										<span className="icon_list_icon">
											<i className="fa-solid fa-circle fa-fw"></i>
										</span>
										<span className="icon_list_text">
											Drive growth
										</span>
									</li>
								</ul>								
								<p className="heading_description mb-20">
                                    Our focus is always on combining <b>creativity + performance</b>.
                                </p>
                            </div>						
                            
                        </div>
                    </div>
					
					<div className="col-lg-6">
                        <div className="image_wrap">
                            <img src={wImg_2} alt="Lens & Lifestyle - About"/>
                        </div>
                    </div>
					
                </div>
            </div>
        </section>		
    );
}

export default WhyUs;